import { NavLink } from "react-router-dom";

export default function TermCondition() {
  return (
    <>
    <div className="privacy-page header-gap">
        <div className="container">
            <div className="row">  

                <div className="col-lg-3 col-md-4 order-2 order-lg-1 order-md-1">
                    <div className="page-sidelink">
                        <h4>Quick links</h4>
                        <ul>
                            <li>
                                <NavLink to="/privacy-policy" className={({ isActive }) => isActive ? "active" : ""}>
                                Privacy Policy
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/terms-and-condition" className={({ isActive }) => isActive ? "active" : ""}>
                                Term And Condition
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-9 col-md-8 order-1 order-lg-2 order-md-2">
                    <div className="privacypage-content">
                        <h1 className='heading'>Term And Condition</h1>
                        <p>Welcome to Saysha Interiors!</p>
                        <p>The Terms and Conditions laid down here shall be exclusively applicable to Saysha Interior's website policies.</p>


                        <h2 className='privacy-smallhead'>Products & Services</h2>
                        <ul>                   
                            <li>Saysha Interiors Pvt Ltd or www.saysha.in provides design, production, and installation services to the customers across various home interior categories.</li>

                            <li>For Customers seeking design ideas and end-to-end services for Modular Kitchens, Wardrobes, TV Units, Bathroom Vanity, and other home furniture products, our expert Design Consultants will tailor Concepts or Design solutions based on customer requirements.</li>

                            <li>Designs beyond 3 options may be charged to the customers.</li>
                        </ul>

                        <h3 className='privacy-smallhead'>Project Timelines</h3>
                        <p>The project is executed within 45 to 60 days from the time of design is frozen in all respects and the site is ready for final measurement. However, the duration is subject to change depending on project size, factory production schedule, and customer requirements.</p>

                        <h4 className='privacy-smallhead'>Payment Terms</h4>
                        <p>A comprehensive quotation is provided to the customer once he/she freezes on a design. Saysha Interior’s design consultant will inform customers of any changes in the shared quotation. Prices as of the date of placing the order will apply to the project.</p>

                        <table className="table table-bordered">
                            <tr>
                                <td>Payment in %</td>
                                <td>Due at the time of</td>
                            </tr>
                            <tr>
                                <td>20% of the order value</td>
                                <td>Booking Project</td>
                            </tr>
                            <tr>
                                <td>40% of the order value</td>
                                <td>Before Production</td>
                            </tr>  
                            <tr>
                                <td>40% of the order value</td>
                                <td>Before Dispatch</td>
                            </tr>   
                        </table>

                        <p>Payments will be accepted through one of the following methods:</p>
                        <ul>
                            <li>NEFT/RTGS Payment</li>
                            <li>Cheque payment</li>
                        </ul>
                        <p>The Order shall be confirmed only after payment confirmation.</p>

                        <h4 className='privacy-smallhead'>Return Policy</h4>
                        <p>As these products are custom made to your specifications. So once confirmed with payment, orders can’t be canceled, returned, or exchanged and payment will not be refundable.</p>


                        <h4 className='privacy-smallhead'>Installations</h4>
                        <p>We do our best to make Installations of products as the product reached your site, however, Installations may be dependent on your site’s conditions.</p>

                        <h4 className='privacy-smallhead'>Offers</h4>
                        <p>The current Offer is applicable for an order value of more than 5 Lacs only.</p>

                        <h4 className='privacy-smallhead'>Warranty</h4>
                        <table className="table table-bordered">
                            <tr>
                                <td>Product Descriptions</td>
                                <td>No. of years</td>
                            </tr>
                            <tr>
                                <td>Cabinets, Shutters, Drawers, and Panels</td>
                                <td>Up to 10 years</td>
                            </tr>
                            <tr>
                                <td>Hardware and Accessories</td>
                                <td>As per the manufacturer warranty</td>
                            </tr>
                            <tr>
                                <td>Handles & Knobs</td>
                                <td>Up to 3 Years</td>
                            </tr>
                            <tr>
                                <td>Lighting Accessories</td>
                                <td>No warranty claims once sold</td>
                            </tr>
                            <tr>
                                <td>On-Site Services</td>
                                <td>Up to 1 Year</td>
                            </tr>
                        </table>

                        <p>1. Saysha Interiors will honor its warranty when</p>
                        <ul>
                            <li>The product supplied and installed is properly maintained and used for normal domestic use.</li>
                            <li>The product is still owned by the original purchaser.</li>
                            <li>The product is still at its original installed position and location</li>
                            <li>The warranty has not expired, subject to limitations set through Saysha Interiors Terms & conditions.</li>
                        </ul>

                        <p>2. Saysha warranty promise does not cover natural wear and tear, or damage caused by rough handling or using the product beyond its intended use.</p>

                        <p>3. The following are not considered as defects: natural wood characteristics such as variations in grain, color mineral streaks, and knots.</p>

                        <p>4. Notify Saysha Interiors within 10 days of any defect first coming into notice, via phone or e-mail info@saysha.in.</p>

                        <p><span>Note:-  25 Years Life Warranty is applicable to our specific & premium products only. ANTI TERMITE, ANTI MOISTURE, ANTI BACTERIAL, ANTI FUNGAL, ANTI GERMS specifications are also applicable to our specific & premium products only.</span></p>

                        <p>In case full payment is not received from customers for any reason, the warranty will be null and void.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
